import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import GreenTick from '../../../../src/pages/client/client_assets/img/green_tick.svg';
import mail_svg from '../../../../src/pages/client/client_assets/img/mail.svg';
import '../../../../src/pages/client/client_assets/css/common.css';
import config from '../../../config/config';

const ResetPasswordForm = ({ GreenTick, lock_svg }) => {

    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {

        e.preventDefault();
    
        // Validate password (e.g., length, special characters)
        if (password.length < 8) {
            setMessage("Password must be at least 8 characters.");
            return;
        }
        
        // Check for at least 6 unique characters
        const uniqueChars = new Set(password.split(''));
        if (uniqueChars.size < 6) {
            setMessage("Password must include at least 6 unique characters.");
            return;
        }
    
        setLoading(true);
    
        // Assuming the token is stored in the URL query parameters
        const queryParams = new URLSearchParams(window.location.search);
        const token = queryParams.get('token');
    
        if (!token) {
            setMessage("Invalid or missing token.");
            setLoading(false);
            return;
        }
    
        // Make the API call to reset the password
        try {
            const response = await fetch('https://api.skepper.in/reset-password.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ password, token }),
            });
    
            const data = await response.json();
            setLoading(false);
    
            if (data.success) 
            {
                setMessage("Your password was reset successfully.");
                setTimeout(() => {
                    navigate('/client'); // SPA navigation for seamless transition
                }, 3000);
            } 
            else 
            {
                setMessage(data.message || "Failed to reset password.");
            }
        } catch (error) {
            setLoading(false);
            setMessage("An error occurred. Please try again.");
        }
    };
    

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="forgot-password-form-content">
            <h1 className="forgot-password-heading">Reset Password</h1>
            <p className="forgot-password-text black_txt">
                Make sure your new password is at least 8 characters and includes at least 6 different characters.
            </p>
            <form onSubmit={handleSubmit}>
                <div className="form-group password-group">
                    <label htmlFor="password">Enter new password</label>
                    <img src={lock_svg} className="lock_icon" alt="Lock icon" />
                    <div className="password-wrapper">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <span className="toggle-password" onClick={togglePasswordVisibility}>
                            <i className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'}`}></i>
                        </span>
                    </div>
                </div>
                <button type="submit" className="login-button mt-5" disabled={loading}>
                    {loading ? 'Resetting...' : 'Reset Password'}
                </button>
            </form>
            {message && (
                message !== 'Your password was reset successfully.' ? (
                    <div className="error_msg text-left">
                        <p className="message">{message}</p>
                    </div>
                ) : (
                    <div className="we_sent">
                        <span>
                            <img src={GreenTick} alt="Success" />
                        </span>
                        <p>Your password was reset successfully.</p>
                    </div>
                )
            )}
        </div>
    );
};

export default ResetPasswordForm;
